<div *ngIf="showComponent && channels$ | async as channels" class="row">
  <div class="container row">
    <div class="col-auto"><h2 i18n="news filter by channel@@news-filter-by-channel" class="widget-header h4 mt-1 featured-news-title">News from:</h2></div>
    <div class="col news-filter">
      <ng-container *ngFor="let channel of definedChannels">
        <button mat-flat-button class="channel-btn filter-button mb-2 mr-2" [routerLink]="['./pages/news']" [queryParams]="{ channel: channel.GUID}"><span>{{channel.Name}}</span></button>
      </ng-container>
    </div>
  </div>
</div>
